import { generateClient } from 'aws-amplify/api'
import { listOrgTransactions as listOrgTransactionsQuery } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export default {
  methods: {
    async listOrgTransactions(input = {}) {
      try {
        const { data, errors } = await client.graphql({
          query: listOrgTransactionsQuery,
          variables: { input },
        })

        const parsed = parseAwsJson(data?.listOrgTransactions)
        if (parsed != null) {
          return parsed
        }

        if (errors?.length) {
          throw new Error(errors[0].message)
        }

        return null
      } catch (error) {
        return {
          status: 'ERROR',
          message: getApiMessage(error, 'Failed to load transactions'),
        }
      }
    },
  },
}
